import PropTypes from 'prop-types';
import './DroughtTable.css';

function DroughtTable({ tableData, onClose }) {
  return (
    <div className="drought-chart-row bg-white shadow-lg rounded-lg p-4">
      <div className="chart relative">
        <div className="d-flex justify-content-between mb-4">
          <h2 className="text-xl font-normal font-national text-gray-800">
            Drought Data Summary
          </h2>
          <div
            onClick={onClose}
            className="chart-close-iconTable p-2"
            title="Close"
            aria-label="Close table"
          >
            X
          </div>
        </div>
        {tableData?.length === 0 ? (
          <div className="text-center text-gray-600">No data available</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-2 text-left text-sm font-medium font-national text-gray-700 border-b">
                    Class
                  </th>
                  <th className="px-4 py-2 text-left text-sm font-medium font-national text-gray-700 border-b">
                    Area Covered (ha)
                  </th>
                  <th className="px-4 py-2 text-left text-sm font-medium font-national text-gray-700 border-b">
                    Percentage
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                  >
                    <td className="px-4 py-2 text-sm font-national text-gray-800 border-b">
                      {row.class_label}
                    </td>
                    <td className="px-4 py-2 text-sm font-national text-gray-800 border-b">
                      {row.area_ha.toLocaleString('en-US', {
                        maximumFractionDigits: 2,
                      })}
                    </td>
                    <td className="px-4 py-2 text-sm font-national text-gray-800 border-b">
                      {row.percentage}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

DroughtTable.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      class_label: PropTypes.string.isRequired,
      area_ha: PropTypes.number.isRequired,
      percentage: PropTypes.string.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DroughtTable;